/*
    Sommaire
 **********************************************************************************************************************/
/*
Fonctions globales :
changerEtapeInscription()
inscriptionDisplayErrorMessage()
majRecapitulatifFormule()
initPageInscription()
initFormInscription()
initFormPaiement()
renvoyerMail()
majReductions()
majHeightBlocs()
majCalculTarifDetail()
majRecapitulatifFormations()


Listeners :
filtrerModulesListener()
selectionnerFormationListener()
majHeightBlocsFormationsModulesListener()
changerEtapeInscriptionListener()
choixOffreListener()


Variables globales :
var templateBlocRecapFormation
var templateBlocRecapModule
 */
/*
    Fonctions globales
 **********************************************************************************************************************/
/**
 * [Permet de faire une transition entre 2 conteneurs]
 * @param  {[objet jQuery]} prevElement [objet jQuery du conteneur à faire disparaitre]
 * @param  {[objet jQuery]} nextElement [objet jQuery du conteneur à faire apparaitre]
 * @param  {[int]} length [durée de la transition]
 * @return -
 */
function changerEtapeInscription(currentElement, nextElement, length) {
    if (length === undefined) {
        length = 400;
    }
    nextElement.css('position', 'absolute').css('visibility', 'hidden');
    var inscriptionContainer = $(".inscription-container");
    var heightConteneur = (currentElement.height() > nextElement.height()) ? currentElement.height() : nextElement.height();
    inscriptionContainer.height(heightConteneur);
    nextElement.css('display', 'none').css('visibility', 'visible');
    currentElement.css('position', 'absolute');
    // Transition des 2 contenus
    currentElement.fadeOut(length, function() {
        currentElement.css('position', 'relative');
    });
    nextElement.fadeIn(length, function() {
        nextElement.css('position', 'relative');
        inscriptionContainer.css('height', 'auto');
    });
}
/**
 * * [Afficher les messages d'erreur des champs du formulaire]
 * @param  {[string]} message [message à afficher dans le zone de message du formulaire]
 * @return -
 */
function inscriptionDisplayErrorMessage(message) {
    var containerMessage = $(".page-inscription .alert-danger");
    // On vide le message si il y en avait un
    containerMessage.html('');
    // Affichage du message
    containerMessage.append(message).removeClass("hidden");
    // Maj de la taille du conteneur
    $(".inscription-container").height($(".inscription-step.step-3").height());
}
/**
 * * [getReduction retourne la valeur de la reduction à appliquer en fonction des formations et modules sélectionnées]
 * @param  {[string]} message [message à afficher dans le zone de message du formulaire]
 * @return -
 */
function getReduction() {
    if ($(".liste-formations .bloc-formation.actif").length > 0 && $(".liste-modules .bloc-module.actif").length < 2) {
        return 25;
    } else if ($(".liste-formations .bloc-formation.actif").length > 0) {
        return 50;
    } else {
        return 0;
    }
}

function getCoefReduction() {
    if ($(".liste-formations .bloc-formation.actif").length > 0 && $(".liste-modules .bloc-module.actif").length < 2) {
        return 0.75;
    } else if ($(".liste-formations .bloc-formation.actif").length > 0) {
        return 0.5;
    } else {
        return 1;
    }
}

/**
 * [majRecapitulatifFormule Met à jour le récapitulatif dans la partie formulaire]
 * @param  {[string]} idFormation [id formation permettant d'afficher le bloc formation dans le formulaire]
 * @param  {[string]} idFormuleFinancement [id de formule permettant du bloc formule dans le bloc formation]
 * @param  {[bool]} offreConfort [identifiant de la formation à mettre à jour dans le champs input caché]
 * @return -
 */
function majRecapitulatifFormule(idFormule, offreConfort = null) {
    // Mise a jour du recapitulatif avec le bon radio button coché pour la formule de financement
    $('.modifier-offre .form-offre').addClass('hidden');
    $('.modifier-offre .offre-' + idFormule).removeClass('hidden');
    $('.modifier-offre .offre-' + idFormule + ' input').prop("checked", true);
}

function conversionAmount (amount) {
    return (amount / 100).toFixed(2).toString().replace(/\./g, ',');
}


/**
 * [Initialise la page d'incription]
 * @return -
 */
function initPageInscription() {
    // Si une formation / module doit être precochée à l'ouverture de la page => on force l'event click sur les boutons de ces formations
    $('.init-formation-checked').each(function() {
        if ($(this).hasClass("bloc-formation")) {
            // Formation précochée
            $(this).find('button').trigger("click");
        } else {
            $(this).trigger("click");
        }
    });
    // Gestion de l'indicateur pays en fonction du champs pays choisi
    $('#indicatif-telephone').text($('#form-pays').find(":selected").data('indictel'));
    $('#form-pays').on('change', function(e) {
        $('#indicatif-telephone').text($(e.currentTarget.selectedOptions).data('indictel'));
    });
}
window.initPageInscription = initPageInscription;

function initFormInscription() {
    // Gestion du formulaire d'inscription :
    $('#inscription-form').on('submit', function(event) {
        event.preventDefault();
        // Objet du formulaire
        var $this = $(this);
        // Recuperation des valeurs
        var data = $this.serialize();
        var dataList = $this.serializeArray();
        var validateForm = 1;
        var errorMessage = '';
        // Envoi de la requête HTTP en mode asynchrone
        $.ajax({
            url: $this.attr('action'),
            method: $this.attr('method'),
            data: data,
            beforeSend: function() {
                $('.container-loader').removeClass('hidden');
                $('.form-group').removeClass("has-error").removeClass("has-success");
                $('.form-group .return-label').remove();
            },
            success: function(data) {
                $('.page-inscription').empty();
                $('.page-inscription').html(data);
                renvoyerMail();
            },
            error: function(error) {
                $('.container-loader').addClass('hidden');
                // Affichage du message d'erreur
                if (typeof error.responseJSON !== 'undefined') {
                    //
                    if (error.responseJSON.success !== 'undefined' && error.responseJSON.success == false) {
                        inscriptionDisplayErrorMessage(error.responseJSON.message);
                    } else {
                        // Recuperation des messages d erreur du validator
                        messagesList = error.responseJSON;
                        // Par defaut, style success à tous les champs
                        $('.form-group').addClass("has-success");
                        $.each(messagesList, function(key, message) {
                            // exception pour la formule de financement
                            if (key === 'choix-pack') {
                                $('#inscription-form .alert-danger')
                                    .html('La formule de financement est invalide !')
                                    .removeClass('hidden');

                            } else {
                                // Pour chaque message d'erreur => on genere un label que l'on place au dessus du champ du formulaire
                                formGroupContainer = $("#form-" + key).closest('.form-group');
                                messageHtml = "<label class='control-label return-label' for='form-" + key + "'>" + message[0] + "</label>";
                                formGroupContainer.removeClass("has-success").addClass("has-error").append(messageHtml);
                            }
                        });
                    }
                } else {
                    inscriptionDisplayErrorMessage("Erreur lors de l'envoi du formulaire, veuillez contacter l'administrateur.");
                }
            }
        });
    });
    initFormPaiement();
}
window.initFormInscription = initFormInscription;

function initFormPaiement() {
    // Gestion du formulaire de paiement :
    $('#paiement-form').on('submit', function(event) {
        event.preventDefault();
        // Objet du formulaire
        var $this = $(this);
        // Recuperation des valeurs
        var data = $this.serialize();
        var dataList = $this.serializeArray();
        var validateForm = 1;
        var errorMessage = '';

        // Envoi de la requête HTTP en mode asynchrone
        $.ajax({
            url: $this.attr('action'),
            data: data,
            beforeSend: function() {
                $('.container-loader').removeClass('hidden');
            },
            success: function(data) {
                // // Chargement du nouveau formulaire dans un conteneur caché
                $(".inscription-step-formulaire-paiement").html(data);
                // // Envoi du nouveau formulaire
                $(".inscription-step-formulaire-paiement #formulaireMercanet").submit();
            },
            error: function(error) {
                $('.container-loader').addClass('hidden');

                // Affichage du message d'erreur
                if (typeof error.responseJSON !== 'undefined') {
                    messagesList = error.responseJSON.message;
                    errorMessage = '';
                    $.each(messagesList, function(i, message) {
                        errorMessage += message[0] + '<br />';
                    });
                    inscriptionDisplayErrorMessage(errorMessage);
                } else {
                    inscriptionDisplayErrorMessage("Erreur lors de l'envoi du formulaire, veuillez contacter l'administrateur.");
                }
            }
        });
    });
}
window.initFormPaiement = initFormPaiement;
/**
 * [renvoyerMail Permet de gérer le clic du bouton de renvoi mail apres remplissage du formulaire d'inscription]
 * @return -
 */
function renvoyerMail() {
    $('#renvoie-mail-inscription').on('submit', function(event) {
        event.preventDefault();
        // Objet du formulaire
        var $this = $(this);
        // Recuperation des valeurs
        var data = $this.serialize();
        $.ajax({
            url: $this.attr('action'),
            type: $this.attr('method'),
            data: data,
            beforeSend: function() {},
            success: function(data) {
                $('#reponse-renvoie-mail').html('<p class="text-green">Un mail vous a été renvoyé.</p>');
            },
            error: function(error) {
                $('#reponse-renvoie-mail').html("<p class=\"text-red\">Une erreur est survenue lors de l'envoie de votre mail, merci de réessayer.</p>");
            }
        });
        return true;
    });
}
/**
 * [majReductions Met a jour les reductions, et donc l'affichage des prix en fonction des formations et modules selectionnes]
 * @return -
 */
function majReductions() {
    $(".liste-reductions  .bloc-reduction").removeClass('actif');
    $(".liste-modules").removeClass('reduction-max');
    if ($(".liste-formations .bloc-formation.actif").length > 0) { // Une reduction est appliquee
        // Afficher l'encart en dessous de la liste des formations
        $('.infos-formations, .info-continuer').addClass('actif');
        // Maj nom de la formation dans l'encart doré
        if ($(".liste-formations .bloc-formation.actif").length == 1) {
            $(".infos-formations .title-infos-formations").show().text($(".liste-formations .bloc-formation.actif .section-titre").text());
        } else {
            $(".infos-formations .title-infos-formations").hide();
        }
        // Masquer phrase info réduction
        $('.infos-reductions').removeClass('actif');
        // Afficher les prix reduis dans les blocs modules
        $(".liste-modules .bloc-module .section-prix").addClass('actif');
        // Débloquer l'offre confort (Etape 2)
        $(".container-offre-confort").removeClass("disabled");
        // Etape 2 - popin liste formations premium : switcher le boutons valider / revenir aux formules
        $(".modal-formations .btn-primary").removeClass("hidden");
        $(".modal-formations .link").addClass("hidden");
        if ($(".liste-modules .bloc-module.actif").length < 2) { // Tarif -25%
            if ($(".liste-modules .bloc-module.actif").length == 1) {
                //Afficher phrase infos selectionner deuxieme module pour reduction
                $('#bloc-demande-selection-deuxieme-module').removeClass('hidden');
            } else {
                //Masquer phrase infos selectionner deuxieme module pour reduction
                $('#bloc-demande-selection-deuxieme-module').addClass('hidden');
            }
            // Maj de la couleur dorée au -25%
            $(".liste-reductions  .bloc-reduction[data-reduction=25]").addClass('actif');
            // Maj des prix des blocs modules
            $(".liste-modules .bloc-module").each(function() {
                var tarifReduit = parseInt($(this).data('mensualiteformule125') + $(this).data('acompteformule125'));
                $(this).find('.section-prix .prix-module-reduit').html(conversionAmount(tarifReduit) + " &euro;");
            });
        } else { // Tarif -50%
            // Maj de la couleur dorée au -50%
            $(".liste-reductions  .bloc-reduction[data-reduction=50]").addClass('actif');
            // Hover = bordure dorée aux blocs modules
            $(".liste-modules").addClass('reduction-max');
            // Maj des prix des blocs modules
            $(".liste-modules .bloc-module").each(function() {
                var tarifReduit = parseInt($(this).data('mensualiteformule150') + $(this).data('acompteformule150'));
                $(this).find('.section-prix .prix-module-reduit').html(conversionAmount(tarifReduit) + " &euro;");
            });
            //Masquer phrase infos selectionner deuxieme module pour reduction
            $('#bloc-demande-selection-deuxieme-module').addClass('hidden');
        }
    } else { // Pas de reduction
        // Masquer l'encart en dessous de la liste des formations
        $('.infos-formations, .info-continuer').removeClass('actif');
        // Afficher phrase info réduction
        $('.infos-reductions').addClass('actif');
        // Masquer les prix reduis dans les blocs modules
        $(".liste-modules .bloc-module .section-prix").removeClass('actif');
        // Bloquer l'offre confort (Etape 2)
        $(".container-offre-confort").addClass("disabled");
        // Etape 2 - popin liste formations premium : switcher le boutons valider / revenir aux formules
        $(".modal-formations .btn-primary").addClass("hidden");
        $(".modal-formations .link").removeClass("hidden");
        //Masquer phrase infos selectionner deuxieme module pour reduction
        $('#bloc-demande-selection-deuxieme-module').addClass('hidden');
    }
}
/**
 * [majHeightBlocsFormationsModules uniformise les hauteur des blocs selon le selecteur passé en paramètre]
 * @return -
 */
function majHeightBlocs(selecteurBloc) {
    var maxHeight = 0;
    var blocHeight = 0;
    $(selecteurBloc).each(function() {
        blocHeight = $(this).height();
        if (maxHeight < blocHeight) {
            maxHeight = blocHeight;
        }
    });
    $(selecteurBloc).height(maxHeight);
}
/**
 * [majCalculTarifDetail [Etape 2 + etape 3] permet d'afficher le detail du prix du prix total des formations pour chaque formule de financement]
 * @return -
 */
function majCalculTarifDetail() {
    // Recuperation de la reduction a appliquer
    var reduction = getReduction();
    var coefReduction = getCoefReduction();
    // Offre Eco : id offre = 1
    $('.inscription-step.step-3 .form-offre').each(function() {
        var nbMensualite = $(this).data('nbmensualite');
        var idOffre = $(this).data('idoffre');
        var prixTotal = 0;
        var acompteTotal = 0;
        var mensualiteTotal = 0;
        var promoTotal = 0;
        var sansPromoTotal = 0;
        // Maj de L'Etape 2 - details des tarifs + etape 3 - details des tarifs pour formations
        $(".liste-formations .bloc-formation.actif").each(function() {
            var prixFormation = parseInt($(this).data("tariftotaloffre" + idOffre));
            var acompteFormation = parseInt($(this).data("acompteformule" + nbMensualite + "0"));
            var mensualiteFormation = parseInt($(this).data("mensualiteformule" + nbMensualite + "0"));
            var promoFormation = parseInt($(this).data("montantpromo"));
            prixTotal = prixTotal + prixFormation;
            acompteTotal = acompteTotal + acompteFormation;
            mensualiteTotal = mensualiteTotal + mensualiteFormation;
            promoTotal = promoTotal + promoFormation;
        });
        // Maj de L'Etape 2 - details des tarifs + etape 3 - details des tarifs pour modules
        $(".liste-modules .bloc-module.actif").each(function() {
            var acompteFormation = parseInt($(this).data("acompteformule" + nbMensualite + reduction));
            var mensualiteFormation = parseInt($(this).data("mensualiteformule" + nbMensualite + reduction));
            var prixFormation = parseInt($(this).data("acompteformule" + 1 + reduction)) + parseInt($(this).data("mensualiteformule" + 1 + reduction));
            var prixInitialFormation = parseInt($(this).data("tariftotaloffre" + idOffre));
            prixTotal = prixTotal + prixFormation;
            acompteTotal = acompteTotal + acompteFormation;
            mensualiteTotal = mensualiteTotal + mensualiteFormation;
            promoTotal = promoTotal + (prixInitialFormation - prixFormation);
        });
        // Convertion en fixant les décimal à 2 (car quand 100.00 devient 100 si pas toFixed(2))
        // On repasse en chaine de caractères les tarifs
        // On remplace le pint par une virgule (car tarifs non anglosaxon)
        sansPromoTotal = conversionAmount((prixTotal + promoTotal));
        prixTotal = conversionAmount(prixTotal);
        acompteTotal = conversionAmount(acompteTotal);
        mensualiteTotal = conversionAmount(mensualiteTotal);
        // Mis à jour des prix dans la modal
        $('.liste-formules .container-offre[data-idoffre=' + idOffre + '] .tarif-total, #modal-offre' + idOffre + ' .prix-total, .modifier-offre .form-offre[data-nbmensualite=' + nbMensualite + '] .prix-total').html(prixTotal);
        $('#modal-offre' + idOffre + ' .details-formule[data-nbmensualite=' + nbMensualite + '] .prix-acompte, .modifier-offre .form-offre[data-nbmensualite=' + nbMensualite + '] .prix-acompte').html(acompteTotal);
        $('#modal-offre' + idOffre + ' .details-formule[data-nbmensualite=' + nbMensualite + '] .prix-mensualite, .modifier-offre .form-offre[data-nbmensualite=' + nbMensualite + '] .prix-mensualite').html(mensualiteTotal);

        // Gestion de la promotion
        $('.liste-formules .container-offre[data-idoffre=' + idOffre + '] .tarif-promo').html(sansPromoTotal);
        // Si aucune promo alors on n'affiche pas de prix barré
        if (promoTotal > 0 ) {
            $('.liste-formules .container-offre[data-idoffre=' + idOffre + '] .offre-promo').removeClass('hidden');
        } else {
            $('.liste-formules .container-offre[data-idoffre=' + idOffre + '] .offre-promo').addClass('hidden');
        }
    });
}
/**
 * [majRecapitulatifFormations permet de mettre à jour le récapitulatif des formations / modules dans l'étape 3 de l'inscription]
 * @return -
 */
function majRecapitulatifFormations(idOffre) {
    var idBloc;
    var libelleBloc;
    var imageUrlBloc;
    var descriptionBloc;
    var prixBloc;
    var templateBloc;
    var reduction = getReduction();
    $('.recap-liste-formations .row').empty();
    // Maj du récapitulatif des formations
    $(".liste-formations .bloc-formation.actif").each(function() {
        idBloc = $(this).data("idformation");
        libelleBloc = $(this).find(".section-titre").text();
        imageUrlBloc = $(this).find(".section-image img").attr('src');
        prixBloc = $(this).data("tariftotaloffre" + idOffre);
        descriptionBloc = $(this).find(".section-description").html();
        templateBloc = templateBlocRecapFormation.replace("{idFormation}", idBloc);
        templateBloc = templateBloc.replace("{libelleFormation}", libelleBloc);
        templateBloc = templateBloc.replace("{libelleFormation}", libelleBloc);
        templateBloc = templateBloc.replace("{imageUrlFormation}", imageUrlBloc);
        templateBloc = templateBloc.replace("{prixFormation}", conversionAmount(prixBloc));
        templateBloc = templateBloc.replace("{descriptionFormation}", descriptionBloc);
        $('.recap-liste-formations .row').append(templateBloc);
    });
    // Maj du récapitulatif des modules
    $(".liste-modules .bloc-module.actif").each(function() {
        idBloc = $(this).data("idformation");
        libelleBloc = $(this).find(".section-titre").text();
        imageUrlBloc = $(this).find(".section-image img").attr('src');
        var acompteFormation = parseInt($(this).data("acompteformule" + 1 + reduction));
        var mensualiteFormation = parseInt($(this).data("mensualiteformule" + 1 + reduction));
        prixBloc = acompteFormation + mensualiteFormation;
        templateBloc = templateBlocRecapModule.replace("{idModule}", idBloc);
        templateBloc = templateBloc.replace("{libelleModule}", libelleBloc);
        templateBloc = templateBloc.replace("{libelleModule}", libelleBloc);
        templateBloc = templateBloc.replace("{imageUrlModule}", imageUrlBloc);
        templateBloc = templateBloc.replace("{prixModule}", conversionAmount(prixBloc));
        $('.recap-liste-formations .row').append(templateBloc);
    });
}
/**
 * Function permettant de nettoyer les erreurs dans l'alert
 * @return {[type]} [description]
 */
function resetErrorMessage() {
    // On vide le message si il y en avait un
    // Et on cache la div
    $(".page-inscription .alert-danger").html('').addClass("hidden");
}
/*
    Listeners
 **********************************************************************************************************************/
/**
 * [filtrerModulesListener Inscription etape 1 - filtre les modules selon le choix dans les cases à cocher]
 * @return -
 */
function filtrerModulesListener() {
    $(".filtre-modules input[type=checkbox]").change(function() {
        if ($('.filtre-modules input[type=checkbox]:checked').length === 0) {
            $(".liste-modules .bloc-module").show();
        } else {
            $(".liste-modules .bloc-module").hide();
            $('.filtre-modules input[type=checkbox]:checked').each(function() {
                var idCentreInteret = $(this).data('idcinteret');
                if (this.checked) {
                    $(".liste-modules .bloc-module[data-cinteret=" + idCentreInteret + "]").show();
                }
            });
        }
    });
}
window.filtrerModulesListener = filtrerModulesListener;
/**
 * [selectionnerFormationListener Inscription etape 1 ou popin etape 2 - listener pour les clics de modules et formations]
 * @return -
 */
function selectionnerFormationListener() {
    // Clic sur une formation (etape 1 ou popin etape 2), ou clic sur module (etape 1) :
    $('.bloc-formation, .liste-formations .bloc-formation .btn.btn-secondary, .bloc-formation-popin, .bloc-formation-popin .btn.btn-secondary, .bloc-module').on('click', function() {
        if (!$(this).hasClass('bloc-module')) {
            // On a cliqué sur formation master
            var idformation = $(this).data("idformation");
            $('.bloc-formation[data-idformation=' + idformation + '], .bloc-formation-popin[data-idformation=' + idformation + ']').toggleClass('actif');
        } else {
            // On a cliqué sur module
            $(this).toggleClass('actif');
            var idformation = $(this).data("idformation");
        }
        majReductions();
        majCalculTarifDetail();
        // Maj Etape 3 - Checkboxs cachés id formations à soumettre au form
        var checkboxFormation = $('.form-formations input[value=' + idformation + ']');
        checkboxFormation.prop("checked", !checkboxFormation.prop("checked"));
        if ($(".liste-formations .bloc-formation.actif, .bloc-module.actif").length > 0) {
            // Au moins 1 formation/module est selectionné
            $('.inscription-step.step-1 .change-step').removeClass('hidden');
        } else {
            // 0 formation selectonnée
            $('.inscription-step.step-1 .change-step').addClass('hidden');
        }
        // Maj etape 2 - on check / désactive le "Cours vidéo en direct" dans les blocs offre
        if ($(".liste-formations .bloc-formation.actif").length > 0) {
            // Au moins 1 formation est selectionnée
            $('.liste-formules .premium-toggle').removeClass('disabled');
        } else {
            // 0 formation selectonnée
            $('.liste-formules .premium-toggle').addClass('disabled');
        }
    });
}
window.selectionnerFormationListener = selectionnerFormationListener;
/**
 * [majHeightBlocsModuleListener Inscription etape 1 - uniformise les hauteur des blocs modules]
 * @return -
 */
function majHeightBlocsFormationsModulesListener() {
    var selecteurBlocsFormations = ".liste-formations .bloc-formation.item-formation .bloc-formation-content";
    var selecteurBlocsModules = ".liste-modules .bloc-module .bloc-module-content";
    var selecteurBlocsFormationsPopin = ".liste-formations .bloc-formation-popin .bloc-formation-content";
    var selecteurBlocsAll = selecteurBlocsFormations + ", " + selecteurBlocsModules + ", " + selecteurBlocsFormationsPopin;
    // >= Format Tablette
    if (Modernizr.mq('(min-width: 768px)')) {
        majHeightBlocs(selecteurBlocsFormations);
        majHeightBlocs(selecteurBlocsModules);
    }
    // Evenement Resize
    $(window).resize(function() {
        // >= Format Tablette
        if (Modernizr.mq('(min-width: 768px) and (max-width:991px)')) {
            if (!$(selecteurBlocsAll).hasClass('lock-min-768')) {
                $(selecteurBlocsAll).addClass('lock-min-768').removeClass('lock-min-992');
                // Reinitialisation hauteurs auto des blocs
                $(selecteurBlocsFormations).css("height", '');
                $(selecteurBlocsFormationsPopin).css("height", '');
                $(selecteurBlocsModules).css("height", '');
                // Calcul des hauteurs : on trouve le bloc avec la hauteur
                majHeightBlocs(selecteurBlocsFormations);
                majHeightBlocs(selecteurBlocsFormationsPopin);
                majHeightBlocs(selecteurBlocsModules);
            }
        } else if (Modernizr.mq('(min-width: 992px)')) {
            $(selecteurBlocsAll).addClass('lock-min-992').removeClass('lock-min-768');
            // Reinitialisation hauteurs auto des blocs
            $(selecteurBlocsFormations).css("height", '');
            $(selecteurBlocsFormationsPopin).css("height", '');
            $(selecteurBlocsModules).css("height", '');
            // Calcul des hauteurs : on trouve le bloc avec la hauteur
            majHeightBlocs(selecteurBlocsFormations);
            majHeightBlocs(selecteurBlocsFormationsPopin);
            majHeightBlocs(selecteurBlocsModules);
        } else {
            // Format Mobile
            $(selecteurBlocsAll).removeClass('lock-min-992').removeClass('lock-min-768');
            // Reinitialisation : hauteurs de blocs par défaut
            $(selecteurBlocsFormations).css("height", '');
            $(selecteurBlocsFormationsPopin).css("height", '');
            $(selecteurBlocsModules).css("height", '');
        }
    });
    // Evenement Ouverture modale liste formations
    $('#modal-formations').on('shown.bs.modal', function(e) {
        $(selecteurBlocsFormationsPopin).css("height", '');
        majHeightBlocs(selecteurBlocsFormationsPopin);
    });
}
window.majHeightBlocsFormationsModulesListener = majHeightBlocsFormationsModulesListener;
/**
 * [changerEtapeInscriptionListener Gère les changements des différentes étapes de la partie inscription]
 * @return -
 */
function changerEtapeInscriptionListener() {
    $(".page-inscription .change-step").click(function(event) {
        event.preventDefault();
        // Si bouton desactivé ou conteneur du bouton désactivé
        if ($(this).hasClass("disabled") || $(this).parents(".disabled").length > 0) {
            $('#modal-formations').modal('show');
            return false;
        }
        // Recuperation de contenu actuel et du prochain contenu à afficher
        var nCurrentEtape = $(this).data("current");
        var nNextEtape = $(this).data("next");
        if (nCurrentEtape == 3) {
            resetErrorMessage();
        }
        
        // Transition des 2 contenus
        changerEtapeInscription($(".step-" + nCurrentEtape), $(".step-" + nNextEtape));
        // Si un attribut ancre est présent :
        if ($(this).attr('anchor')) {
            $('html, body').animate({
                scrollTop: $($.attr(this, 'anchor')).offset().top
            }, 500);
        }
    });
}
window.changerEtapeInscriptionListener = changerEtapeInscriptionListener;
/**
 * [myListenerFonction Permet de mettre à jour le récapitulatif dans la partie formulaire]
 * @return -
 */
function choixOffreListener() {
    // Page inscription - Etape 2
    $('.page-inscription .maj-formule').click(function(event) {
        event.preventDefault();
        var idFormule;
        var idOffre;
        // Offre eco / confort
        var modalContainer = $(this).parents('.modal-body');
        idFormule = modalContainer.find('.details-formule .radio input:checked').data('idformule');
        idOffre = modalContainer.data('idoffre');
        majRecapitulatifFormule(idFormule);
        majRecapitulatifFormations(idOffre);
    });

    // Si Click sur offre désactivée alors ouverture de la popup
    $('.container-offre-confort.disabled').on("click", function(event) {
        if ($(this).hasClass('disabled')) {
            $('#modal-formations').modal('show');
            majHeightBlocs(".liste-formations .bloc-formation-popin .bloc-formation-content");
        }
        majReductions();
    });
}
window.choixOffreListener = choixOffreListener;

function conversionInscription(urlRedirection = null, currentRoute) {
    setTimeout(redirectionUser, 1000);
    var redirectUser = false;

    function redirectionUser() {
        if (!redirectUser) {
            redirectUser = true;
            $(location).attr('href', urlRedirection);
        }
    }

    // ga sera instancié si les cookies ont été autorisés via tarteaucitron
    if (urlRedirection != null && typeof ga !== 'undefined') {
        ga('set', 'location', currentRoute);
        ga('send', 'event', 'Inscription', 'Redirection', 'Inscription-Eleve', {
            'hitCallback': redirectionUser
        });
    }
}
window.conversionInscription = conversionInscription;
// Gestion du "Voir toutes les mensualité"
$('.see-all').on('click', function() {
    $(this).parents().siblings().removeClass('hidden');
    $(this).remove();
});
$("input[name='nomformule']").on('click', function() {
    $('.modal-offre.in .maj-formule').removeClass('hidden');
    $('.modal-offre:not(.in)').children("input[name='nomformule']").prop('checked', false);
    $('.modal-offre:not(.in) .maj-formule').addClass('hidden');
});

/*
    Variables globales
 **********************************************************************************************************************/
var templateBlocRecapFormation = "\
<div class='solo-formation col-xs-12' style='margin-bottom: 15px;'>\
       <div class='bloc-formation' data-idformation='{idFormation}'>\
           <div class='bloc-formation-content'>\
               <span class='bloc-formation-bandeau'>Premium</span>\
               <div class='description'>\
                       <div class='section-image hidden-xs'>\
                           <img src='{imageUrlFormation}' alt='Image {libelleFormation}'>\
                       </div>\
                   <div class='clearfix clearfix-solo-none'></div>\
                   <h4 class='no-margin-top'>Formation :<br /> {libelleFormation}</h4>\
                   <span class='info-prix' style='display: block;'> {prixFormation} &euro;</span>\
                   {descriptionFormation}<br /><br />\
               </div>\
               <div class='clearfix'></div>\
           </div>\
       </div>\
   </div>\
";
var templateBlocRecapModule = "\
<div class='col-xs-12 col-sm-6' style='margin-bottom: 15px;'>\
    <div class='bloc-module' data-idformation='{idModule}'>\
        <div class='section-image'>\
            <img src='{imageUrlModule}' alt='Image {libelleModule}'>\
        </div>\
        <h5>&bull; Module : {libelleModule}</h5>\
        <span class='info-prix' style='display: block;'> {prixModule} &euro;</span>\
        <div class='clearfix'></div>\
    </div>\
</div>\
";
